import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { CommonModule } from '@angular/common';
import { Auth } from './services/auth';
import { LoaderService } from './services/loader';
import { environment } from '../environments/environment';
import { Sso } from './services/sso';
import { WebStorage } from './services/web-storage';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet],
  providers: [OAuthService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'pulse-agent';
  isAuthenticated: boolean = false;
  user: any = null;

  constructor(private router: Router, private route: ActivatedRoute, public authService: Auth,
    private readonly ssoService: Sso, private readonly webStorageService: WebStorage, private cd: ChangeDetectorRef) {
    this.isAuthenticated = authService.getAccessToken() ? true : false;
  }

  async ngOnInit() {
    const env = environment.name || '';
    console.log('Current environment:', env);
    this.route.queryParams.subscribe(async (params) => {
      console.log('Query Params:', params);
      const associateId = params['EncryptedAssociateId'] || params['associateId'] || null;
      const code = params['code'] || null;
      if (associateId && associateId !== '') {
        console.log('Associate ID from query params:', associateId);
        this.authService.associateIdLogin = true;
        this.router.navigate(['/auth-callback'], { queryParams: { associateId: associateId } });
      } else if (['prod', 'uat'].includes(env.toLowerCase())) {
        if (environment.loginFeature) {
          console.log('Initializing SSO service for prod/uat environment...');
          await this.ssoService.initialize();
        } else {
          this.router.navigate(['/login']);
        }
      } else {
        if (code && code !== '' && !this.isAuthenticated) {
          this.router.navigate(['/auth-callback'], { queryParams: { code: code } });
        }
      }
    });
    // if (['prod', 'uat'].includes(env.toLowerCase())) {
    //   await this.ssoService.initialize();
      // let user = this.webStorageService.retrieveItem('cu');
      // console.log('APP-Component: User from session storage:', user);
      // if (user) {
      //   console.log('APP-Component: Emitting user through SSO service');
      //   this.ssoService.$user.next(user);
      //   this.user = user;
      //   this.cd.detectChanges();
      // }
      // this.ssoService.$user.subscribe((usr: any) => {
      //   if (usr != null) {
      //     console.log('APP-Component: Received user from SSO service:', usr);
      //     this.user = usr;
      //     if (usr.roles && usr.roles.length > 1 && usr.roles.includes('riskofficers') && usr.roles.includes('supervisors')) {
      //       this.router.navigate(['/role-select']);
      //     } else {
      //       if (usr.role === 'flms') {
      //         this.router.navigate(['/chat']);
      //       } else if (usr.role === 'supervisors') {
      //         this.router.navigate(['/review']);
      //       } else if (usr.role === 'riskofficers') {
      //         this.router.navigate(['/review']);
      //       } else {
      //         this.router.navigate(['/unauthorized']);
      //       }
      //     }
      //     this.cd.detectChanges();
      //   } else {
      //     console.log('APP-Component: User is null, navigating to home');
      //     this.user = usr;
      //     this.cd.detectChanges();
      //     this.router.navigate(['']);
      //     // window.location.reload();
      //   }
      // });
      // this.router.navigate(['/login']);
    // } else {
    //   this.route.queryParams.subscribe((params) => {
    //     console.log('Query Params:', params);
    //     const code = params['code'];
    //     if (code && code !== '' && !this.isAuthenticated) {
    //       this.router.navigate(['/auth-callback'], { queryParams: { code: code } });
    //     }
    //   });
    // }
  }
  
}
